import { render, staticRenderFns } from "./revision.vue?vue&type=template&id=88f22122"
import script from "./revision.vue?vue&type=script&lang=js"
export * from "./revision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88f22122')) {
      api.createRecord('88f22122', component.options)
    } else {
      api.reload('88f22122', component.options)
    }
    module.hot.accept("./revision.vue?vue&type=template&id=88f22122", function () {
      api.rerender('88f22122', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/revision/revision.vue"
export default component.exports